import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Services
import { SegmentInsertService } from '../../service/segment-insert/segment-insert.service';

@Component({
	selector: 'app-segment-insert',
	templateUrl: './segment-insert.component.html',
	providers: [
		SegmentInsertService,
		HttpModule
	]
})

export class SegmentInsertComponent implements OnInit {
	segment: FormGroup;
	Descricao: string = "";
	Status: boolean;
	private token;
	public permissoes: any[] = [];

	constructor(fb: FormBuilder, private segmentInsertService: SegmentInsertService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.segment = fb.group({
			'Descricao': [null, Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
	}

	addSegment(value: any) {
		this.segmentInsertService.insertSegment(this.token, value).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Segmento cadastrado com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/segmento');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/segmento');
	}
}



// WEBPACK FOOTER //
// ./src/app/segments/component/segment-insert/segment-insert.component.ts